/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDeveloperApiToken } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useCreateDeveloperApiToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { name: string }) => createDeveloperApiToken(payload).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries(userQueryKeys.developerApiTokens({}).slice(0, 1));
    },
  });
}
